import { AxiosRequestConfig } from "axios";
// const baseURL = "http://vortexapi.trial.hk/api/"; //Pro
// const baseURL = "http://localhost:59732/api/"; //Local
//const baseURL = "https://elmsapi.fxx.hk/api/"; //FX Pro
//const baseURL = "http://elmsdevapi-t.bex.hk/api/"; //Test
const baseURL = "http://hrm-mgtapi.bex.hk/api/"; //当前自己公司(BEX)使用HRM的API地址
// const baseURL = "http://hrm-mgtv2api.trial.hk/api/"; //当前自己Test部署的API地址KYOTOT测试环境(login/DEMOT==>login/KYOTOT  sa/Bexadmin)(login/DEMO admin/123456)
// const baseURL = "http://HRM-mgtapi.kyoto-food.com/api/"; //当前JS部署的KYOTO正式环境(login/KYOTO  sa/Bexadmin)
// const baseURL = "https://eleave.essilorchina.com:8443/api/"; //Essilor地址(login/Essilor  admin/admin1)
// const baseURL = "https://hrm-mgtapi.dmc-gas.com.hk/api/"; //DMC地址 (login/DMC  admin/Ad@1029dmc)
const MizarBaseUrl = "https://apiv3.mizar.hk/";

export const defaultAPICloudSetting = {
  baseURL: baseURL,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json"
  }
};

export const defaultapiSetting = {
  baseURL: baseURL,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json"
  }
};

export const defaultMizarAPISetting = {
  baseURL: MizarBaseUrl,
  timeout: 200000,
  headers: {
    "Content-Type": "application/json"
  }
};

export const endPoints = {
  server: {
    getServerRouter: "serial/getServerRouter",
    getServerRouterByCompCode: "serial/getServerRouterByCompCode",
    checkIsReg: "phoneStatus/checkIsReg",
    regPhone: "phoneStatus/reg"
  },

  authentication: {
    login: "/authentication/login"
  },

  mm: {
    get: "/mm/list",
    save: "/mm/save",
    delete: "/mm/delete"
  },
  localization: "localization/",
  loginCompCode: "/authentication/login/compCode",
  resetPassword: "/authentication/resetpassword",
  forgotpassword: "/authentication/forgotpassword",
  changeLang: "/authentication/updateLang",
  approveLeave: "/approval/approveleave",
  approveOutdoorwork: "/approval/approveevent",
  rejectLeave: "/approval/rejectleave",
  rejectOutdoorwork: "/approval/rejectevent",
  getApprovalOutdoorkwork: "/approval/events",
  getApprovalLeave: "/approval/leaves",
  deleteLeaveApp: "/approval/delete",
  cancelLeaveApp: "/user/leave/cancelLeaveApp",
  deleteLeaveAppAttachments: "/user/leave/deleteLeaveAppAttachments",
  getUsers: "/users",
  getUserById: "/user",
  getUserLeaves: "/user/leaves",
  getLeaveAttachments: "/user/leaveAttachments",
  uploadAttachments: "/user/uploadAttachments",
  getUserTree: "/user/userstree",
  addUser: "/user/add",
  updateUser: "/user/update",
  deleteUser: "/user/delete",
  addLeaveApp: "/user/leave/add",
  editLeaveApp: "/user/leave/edit",
  adjustLeave: "/user/leave/adjleave",
  getLeaveEndDate: "/user/leave/getenddate",
  getLeavebalasoftoday: "/leave/leavebalasoftoday",
  checkLeaveTypeBalance: "/user/checkleavetypebalance",
  uploadProfileImage: "/user/uploadProfileImage",
  getSupervisorListForAddOrEdit: "/user/getsupervisorlistforaddedit",
  getAllUsers: "/user/getAllUsers",
  //Maintainence
  getWorkTypes: "/worktypes",
  addWorkType: "/workType/add",
  updateWorkType: "/workType/update",
  deleteWorkType: "/workType/delete",
  getLeaveTypes: "/leavetypes",
  addLeaveType: "/leaveType/add",
  updateLeaveType: "/leaveType/update",
  deleteLeaveType: "/leaveType/delete",
  getHolidays: "/holidays",
  deleteHoliday: "/holiday/delete",
  updateHoliday: "/holiday/update",
  addHoliday: "/holiday/add",
  saveHoliday:"holiday/saveHoliday",
  syncfromGov: "/holiday/syncfromGov",
  getStaffGrades: "/staffgrades",
  addStaffGrade: "/staffgrade/add",
  updateStaffGrade: "/staffgrade/update",
  deleteStaffGrade: "/staffgrade/delete",
  getLeavePlans: "/leaveplans",
  deleteLeavePlan: "/leaveplan/delete",
  addLeavePlan: "/leaveplan/add",
  updateLeavePlan: "/leaveplan/update",
  getUserGroups: "/usergroups",
  addUserGroup: "/usergroup/add",
  updateUserGroup: "/usergroup/update",
  deleteUserGroup: "/usergroup/delete",
  reportUserList: "/report/userList",
  getLeaveBalance: "/report/staff/allleavebalance",
  getStaffMonthlyLeaveBalance: "/report/staff/monthlyleave",
  getStaffAttendance: "/report/staff/attendance",
  updateStaffAttendance: "/report/staff/attendance/update",
  getStaffOutdoorworkAllowance: "/report/staff/outdoorallowance",
  sendEmail: "/report/monthlybalance/sendmail",
  IRDList: "report/taxReturn/IRDList",
  expToXml: "report/taxReturn/expToXml",
  printIRD: "report/taxReturn/printIRD",
  printIR56M2: "report/taxReturn/printIR56M2",
  getOutdoorworks: "/events",
  getOutdoorworkById: "/event",
  deleteOutdoorwork: "/event/delete",
  finishOutdoorwork: "/event/finish",
  addOutdoorwork: "/event/add",
  modifyOutdoorwork: "/event/update",
  getUserGroupRight: "/usergroupright",
  updateUserGroupRight: "/usergroupright/edit",
  getMenuRightForUser: "/usergroupright/user/menurights",
  getSysParams: "/datasync/getsysparams",
  insertOrUpdateTimecard: "/timecard/insertattendance",
  updateTimeCard: "/timecard/UpdateTimeCard",

  //EmployType
  getAllEmployTypeByPagination: "/getAllEmployTypeByPagination",
  getEmployTypes: "/getAllEmployTypes",
  getEmployTypeDetail: "/employType/GetEmployType",
  addEmployType: "/employType/add",
  updateEmployType: "/employType/update",
  deleteEmployType: "/employType/delete",

  //Jobs
  getAllJobs: "/getAllJobs",
  getAllJobsByPagination: "/getAllJobsByPagination",
  getJobDetail: "/jobs/GetJobDetailByJobCode",
  addJob: "/jobs/add",
  updateJob: "/jobs/update",
  deleteJob: "/jobs/delete",

  //Academic
  getAllAcademicsByPagination: "academics/getAllAcademicsByPagination",
  getAllAcademics: "/academics/getAllAcademics",
  getAcademicsDetail: "/academics/getAcademicDetailByAcademicCode",
  addAcademics: "/academics/add",
  updateAcademics: "/academics/update",
  deleteAcademics: "/academics/delete",

  //Skills & Certs
  getAllSkillCert: "/getAllSkillCert",
  getAllSkillCertByPagination: "/getAllSkillCertByPagination",
  getAllSkillCertList: "/skillCert/getAllSkillCertList",
  getAnsType: "/skillCert/getAnsType",
  getSkillCertDetailByItem: "/skillCert/getSkillCertDetailByItem",
  addSkillCert: "/skillCert/add",
  updateSkillCert: "/skillCert/update",
  deleteSkillCert: "/skillCert/delete",

  //Banks
  getAllBanks: "/getAllBanks",
  getAllBanksByPagination: "/getAllBanksByPagination",
  getBankDetailByBankCode: "/banks/getBankDetailByBankCode",
  addBank: "/banks/add",
  updateBank: "/banks/update",
  deleteBank: "/banks/delete",

  //SourceOfApp
  getAllSourceOfAppsByPagination: "academics/getAllSourceOfAppsByPagination",
  getAllSourceOfApps: "/sourceOfApp/getAllSourceOfApps",
  getSourceOfAppDetail: "/sourceOfApp/getSourceOfAppDetailBySACode",
  addSourceOfApp: "/sourceOfApp/add",
  updateSourceOfApp: "/sourceOfApp/update",
  deleteSourceOfApp: "/sourceOfApp/delete",

  //Benefits
  getAllBenefitByStaffGrade: "/getAllBenefitByStaffGrade",
  getAllBenefits: "/getAllBenefits",
  getAllBenefitsByPagination: "/getAllBenefitsByPagination",
  getBenefitDetail: "/benefits/getBenefitDetailByPlanCode",
  addBenefit: "/benefits/add",
  updateBenefit: "/benefits/update",
  deleteBenefit: "/benefits/delete",

  //Document Template
  getDocTypes: "/docTypes",
  getAllSysVar: "/SysVar/SysVars",
  getAllDocTempListByType: "/docTemp/getAllDocTempListByType",
  getAllDocTempList: "/docTemp/getAllDocTempList",
  getDocTempDetailByTypeAndTempCode:
    "/docTemp/getDocTempDetailByTypeAndTempCode",
  addDocTemp: "/docTemp/add",
  updateDocTemp: "/docTemp/update",
  deleteDocTemp: "/docTemp/delete",

  //District
  getDistrict: "/getAllDistrict",
  getAllDistrictByPagination: "/getAllDistrictByPagination",
  getDistrictDetail: "/district/getDistrictDetailByCountry",
  addDistrict: "/district/add",
  updateDistrict: "/district/update",
  deleteDistrict: "/district/delete",

  //Employee
  getAllIdTypes: "/getAllIdTypes",
  addIdType: "/IDType/add",
  updateIdType: "/IDType/update",
  deleteIdTypes: "/IDType/delete",
  getMaritalStatus: "/getAllmaritalStatus",
  addMaritalStatus: "/MaritalStatus/add",
  deleteMaritalStatus: "/MaritalStatus/delete",
  updateMaritalStatus: "/MaritalStatus/update",
  getRelationship: "/getAllRelationship",
  addRelationship: "/Relationship/add",
  updateRelationship: "/Relationship/update",
  deleteRelationship: "/Relationship/delete",
  getCompany: "/getAllCompany",
  getByCompanCode: "/getByCompanCode",
  getStaffLists: "/staff/getAllStaffLists",
  getAllStaffList: "/staff/getAllStaffList",
  getStaffDetail: "/staff/getStaffDetail",
  getStaffType: "/staff/getStaffType",
  printStaff: "staff/printStaff",
  addStaff: "/staff/addStaff",
  updateStaff: "/staff/updateStaff",
  deleteStaff: "/staff/deleteStaff",
  getStaffLeaveBal: "/staff/LeaveBal",
  getStaffgrades: "/getAllStaffgrades",
  getEmployStatus: "/getAllEmployStatus",
  addEmployStatus: "/EmployStatus/add",
  updateEmployStatus: "/EmployStatus/update",
  deleteEmployStatus: "/EmployStatus/delete",
  getDepartments: "/getAllDepartments",
  addDepartment: "/Department/add",
  updateDepartment: "/Department/update",
  deleteDepartments: "/Department/delete",
  getTeams: "/getAllTeams",
  addTeam: "/Team/add",
  updateTeam: "/Team/update",
  deleteTeams: "/Team/delete",
  getStaffByNameMobileKeyWordsAndDob:
    "/staff/getstaffbynamemobilekeywordsanddob",
  getStaffByNameMobileEmailAndDob: "/staff/getstaffbynamemobileemailanddob",
  getStaff: "/staff/GetStaff",
  getStaffListOnDuty: "/staff/StaffOnDuty",
  getStaffTrace: "/staff/StaffTrace",

  //Job Ads
  getAllJobAdsList: "/jobAds/getAllJobAdsList",
  getJobadListForCandidates: "/jobAds/getjobadListforCandidate",
  getJobAdsDetailByJobAdCode: "/jobAds/getJobAdsDetailByJobAdCode",
  getAllJobAdListByCandidateId: "jobAds/getAllJobAdListByCandidateId",
  saveJobAd: "/jobAds/saveJobAd",
  deleteJobAds: "/jobAds/delete",

  //InviteNew Candidate
  getCandidateInvitedList: "/candidateinvited/getcandidateinvitedlist",
  getCandidateInvited: "/candidateinvited/getcandidateinvited",
  getCandidateInvitedByCandIdAndJobAdcode:
    "candidateinvited/getCandidateInvitedByCandIdAndJobAdcode",
  addCandidateInvited: "/candidateinvited/add",
  updateCandidateInvitedUpdate: "/candidateinvited/update",
  updateJobApplication: "candidateinvited/updatejobapplication",
  updateCandidateJobApplication: "candidateinvited/updateCandidateJob",
  checkInterviewerPwd: "candidateinvited/checkInterviewerPwd",
  verifyCandidate: "/candidateinvited/verifycandidate",
  validateToken: "/candidateinvited/validatetoken",
  getallcandidateinvitedlistbycandid:
    "/candidateinvited/getallcandidateinvitedlistbycandid",
  getAllCandidateInvitedByNameMobileKeyWord:
    "candidateinvited/getAllCandidateInvitedByNameMobileKeyWord",
  getAllCandidateInvitedList: "candidateinvited/getAllCandidateInvitedList",
  getCandidateDetailByCandIdAndJobAdcode:
    "candidateinvited/getCandidateDetailByCandIdAndJobAdcode",
  getCandidateInvitedDetailByCandId:
    "candidateinvited/getCandidateInvitedDetailByCandId",
  //Interview
  getPayCycleType: "intAssess/getPayCycleType",
  getAllStatus: "intAssess/getAllStatus",
  getAllAssessTemp: "assessTemp/getAllAssessTemp",
  addAssessTemp: "AssessTemp/add",
  updateAssessTemp: "AssessTemp/update",
  deleteAssessTemp: "AssessTemp/delete",
  getIntAssessHdrDetail: "intAssess/getIntAssessHdrDetail",
  getAllIntAssessHdrList: "intAssess/getAllIntAssessHdrList",
  getAllIntAssessHdrByCandIdAndJobCode:
    "intAssess/getAllIntAssessHdrByCandIdAndJobCode",
  getAllCalendarData: "intAssess/getAllCalendarData",
  getAllEnquiryIntAssessHdrList: "intAssess/getAllEnquiryIntAssessHdrList",
  getAllEnquiryIntAssessHdrByJobCodeAndStatus:
    "intAssess/getAllEnquiryIntAssessHdrByJobCodeAndStatus",
  getNewIntAssessHdrDetail: "intAssess/getNewIntAssessHdrDetail",
  saveIntAssess: "intAssess/saveIntAssess",
  saveIntSchedule: "intAssess/saveIntSchedule",
  updateIntSchedule: "intAssess/updateIntSchedule",
  saveIntScheduleAndStaff: "intAssess/saveIntScheduleAndStaff",
  deleteIntAssess: "intAssess/deleteIntAssess",

  //Staff Letter
  getStaffLetterList: "staffLetter/getStaffLetterList",
  getStaffLetterDetail: "staffLetter/getStaffLetterDetail",
  printStaffLetter: "staffLetter/printStaffLetter",
  getDocTempDetail: "staffLetter/getDocTempDetail",
  getStaffLetterDetailByStaffId: "staffLetter/getStaffLetterDetailByStaffId",
  addStaffLetter: "staffLetter/addStaffLetter",
  updateStaffLetter: "staffLetter/updateStaffLetter",
  deleteStaffLetter: "staffLetter/deleteStaffLetter",

  //Staff Probation
  getPorbResultType: "staffProbationHdr/getPorbResultType",
  getAllPorbAssessTemp: "staffProbationHdr/getAllPorbAssessTemp",
  getStaffProbationDetail: "staffProbationHdr/getStaffProbationDetail",
  getAllStaffProbationList: "staffProbationHdr/getAllStaffProbationList",
  saveStaffProbation: "staffProbationHdr/saveStaffProbation",
  updateStaffProbation: "staffProbationHdr/updateStaffProbation",
  deleteStaffProbation: "staffProbationHdr/deleteStaffProbation",

  syncAttendance: "timecard/SyncAttendance",

  //company
  getAllCompanyList: "company/getAllCompanyList",
  getCompanyDetail: "company/getCompanyDetail",
  addCompany: "company/add",
  updateCompany: "company/updateCompany",
  deleteCompany: "company/delete",

  //Doc Type
  getAllDocTypesByPagination: "docTypes/getAllDocTypesByPagination",
  getDocTypeDetailByDocTypeCode: "docTypes/getDocTypeDetailByDocTypeCode",
  addDocType: "docTypes/add",
  updateDocType: "/docTypes/update",
  deleteDocType: "/docTypes/delete",

  //Shift Type
  getShiftType: "/Shift",
  addShiftType: "/Shift/NewShift",
  updateShiftType: "/Shift/UpdateShift",
  deleteShiftType: "/Shift/DeleteShift",

  //Roster
  getRoster: "/Roster",
  genRoster: "/Roster/GenRoster",
  addRoster: "/Roster/NewRoster",
  updateRoster: "/Roster/UpdateRoster",
  deleteRoster: "/Roster/DeleteRoster",
  ImportRoster: "/Roster/ImportRoster",

  // RosterPlans
  getRosterPlans: "/RosterPlan/GetRosterPlan",
  addRosterPlan: "/RosterPlan/NewRosterPlan",
  updateRosterPlan: "/RosterPlan/UpdateRosterPlan",
  deleteRosterPlan: "/RosterPlan/DeleteRosterPlan",

  // Autopays
  // getAutopays: "/Autopay/GetAutopay",
  // addAutopay: "/Autopay/NewAutopay",
  // updateAutopay: "/Autopay/UpdateAutopay",
  // deleteAutopay: "/Autopay/DeleteAutopay",

  //Location
  getLocationList: "/Locations",
  getLocation: "/Location",
  addLocation: "/Location/NewLocation",
  updateLocation: "/Location/UpdateLocation",
  deleteLocation: "/Location/DeleteLocation",

  //Payroll Profile
  getPayProfile: "/payroll/profile/all",
  updatePayProfile: "/payroll/profile/update",

  //Payroll Group
  getPayGroup: "/payroll/group/all",
  updatePayGroup: "/payroll/group/save",
  addPayGroup: "/payroll/group/save",
  deletePayGroup: "/payroll/group/delete",

  //Payroll Type
  getPayType: "/payroll/type/all",
  updatePayType: "/payroll/type/save",
  addPayType: "/payroll/type/save",
  deletePayType: "/payroll/type/delete",

  //Payroll Method
  getPayMethod: "/payroll/method/all",
  updatePayMethod: "/payroll/method/save",
  addPayMethod: "/payroll/method/save",
  deletePayMethod: "/payroll/method/delete",

  //Payroll Trial
  getPayrollTrialList: "/payroll/trial/cycle",
  getPayrollTrialDtl: "/payroll/trial/staff",
  savePayrollTrialItem: "/payroll/trial/save",
  sendPayrollTrialItem: "/payroll/trial/submit",
  deletePayrollTrialItem: "/payroll/trial/delete",
  getPayrollTrialMsg: "/payroll/trial/approvalLog",
  exportPayrollTrial: "ExportPayrollTrial",
  approvePayrollTrial: "/payroll/trial/approval",
  printPayrollTrial: "/payroll/trial/print",
  exportAutopayFiles: "/payroll/AutopayFiles",

  //Special Payment
  getSpecialPaymentList: "/payroll/special",
  getSpecialPaymentDtl: "/payroll/special/detail",
  saveSpecialPayment: "/payroll/SaveSpecialPayment",
  addSpecialPayment: "payroll/special/create",
  deleteSpecialPayment: "/payroll/special/delete",
  getSpecialPaymentMsg: "/payroll/special/approvalLog",
  importSpecialPayment: "/payroll/special/import",
  printSpecialPayment: "/printSpecialPayment",
  sendSpecialPayment: "/payroll/special/submit",
  approveSpecialPayment: "/payroll/special/approval",
  exportSpecialPayment: "exportSpecialPayment",

  //Payroll Adjustment
  getPayrollAdjustmentList: "/payroll/payadj",
  importPayrollAdjustmentList: "/payroll/payadj/import",
  savePayrollAdjustment: "/payroll/payadj/save",
  deletePayrollAdjustment: "/payroll/payadj/delete",

  //Final Payment
  getFinalPayment: "/payroll/FinalPays",
  saveFinalPayment: "/payroll/SaveFinalPayment",
  delFinalPayment: "/payroll/DelFinalPayment",
  submitFinalPayment: "/payroll/SubmitFinalPayment",
  printFinalPayment: "/payroll/final/print",
  approveFinalPayment: "/payroll/ApproveFinalPayment",

  // IncType
  getIncTypes: "/payroll/payadj/inctypes",
  saveIncType: "/payroll/payadj/saveinc",
  deleteIncType: "/payroll/payadj/delinc",

  //staffFixAlw
  getStaffFixAlws: "/staffFixAlws",
  addStaffFixAlw: "/staffFixAlw/add",
  updateStaffFixAlw: "/staffFixAlw/update",
  deleteStaffFixAlw: "/staffFixAlw/delete",

  //SysVar
  getSysVarData: "/SysVar/ResolveFormula"
};



// WEBPACK FOOTER //
// ./src/constants/apiSetting.js